import type { MenuItem, CategoryInfo } from '@/types';

export const categories: CategoryInfo[] = [
  { id: 'appetizers', name: 'Appetizers', nameEs: 'Entradas', icon: 'UtensilsCrossed' },
  { id: 'bibimbap', name: 'Walking Down the Street', nameEs: 'Bibimbap', icon: 'Bowl' },
  { id: 'street-style', name: 'Street Style', nameEs: 'Estilo Callejero', icon: 'Sandwich' },
  { id: 'fried-chicken', name: 'K-Bomb Fried Chicken', nameEs: 'Pollo Frito K-Bomb', icon: 'Drumstick' },
  { id: 'plates', name: 'KPC Plates', nameEs: 'Platos KPC', icon: 'Plate' },
  { id: 'kids', name: 'Kids Meal', nameEs: 'Menú Infantil', icon: 'Baby' },
  { id: 'sides', name: 'Sides', nameEs: 'Acompañamientos', icon: 'Fries' },
];

export const menuItems: MenuItem[] = [
  // Appetizers
  {
    id: 'app-1',
    name: 'Original Tater Tots',
    description: 'Crispy tater tots with corn cheese, house special sauces, and green onions',
    price: 7.99,
    category: 'appetizers',
    image: '/images/tater-toast-original.jpg',
    popular: true,
    allergens: ['gluten', 'dairy', 'soy', 'eggs'],
  },
  {
    id: 'app-2',
    name: 'Korean Carbonara Tater Tots',
    description: 'Loaded crispy tater tots drenched in our gochujang carbonara blend, melted corn cheese, house sauces and green onion',
    price: 9.45,
    category: 'appetizers',
    image: '/images/tater-toast-carbonara.jpg',
    allergens: ['gluten', 'dairy', 'soy', 'eggs'],
  },
  {
    id: 'app-3',
    name: 'Bulgogi Tater Tots',
    description: 'Crispy tater tots piled with juicy bulgogi beef, corn cheese, house-made sauces, and green onions',
    price: 14.85,
    category: 'appetizers',
    image: '/images/tater-toast-bulgogi.jpg',
    popular: true,
    allergens: ['gluten', 'dairy', 'soy', 'sesame'],
  },
  {
    id: 'app-4',
    name: 'Mandu',
    description: 'Korean dumpling, 4 pcs. Choice of Veggie or Beef, served with ponzu sauce',
    price: 8.45,
    category: 'appetizers',
    image: '/images/mandu.jpg',
    options: [
      { id: 'mandu-veggie', name: 'Veggie', price: 0 },
      { id: 'mandu-beef', name: 'Beef', price: 0 },
    ],
    allergens: ['gluten', 'soy', 'sesame'],
  },

  // Walking Down the Street - Bibimbap
  {
    id: 'bib-1',
    name: 'Bibimbap Bulgogi Beef',
    description: 'Stacked with signature coleslaw, pickled radish, spinach, carrots and seaweed salad. All topped with our famous house sauces and sunny side egg',
    price: 17.25,
    category: 'bibimbap',
    image: '/images/bibimbap-bulgogi.jpg',
    popular: true,
    allergens: ['gluten', 'eggs', 'soy', 'sesame'],
  },
  {
    id: 'bib-2',
    name: 'Bibimbap Spicy Chicken',
    description: 'Stacked with signature coleslaw, pickled radish, spinach, carrots and seaweed salad. All topped with our famous house sauces and sunny side egg',
    price: 16.25,
    category: 'bibimbap',
    image: '/images/bibimbap-spicy-chicken.jpg',
    spicy: true,
    allergens: ['gluten', 'eggs', 'soy', 'sesame'],
  },
  {
    id: 'bib-3',
    name: 'Bibimbap Crispy Chicken',
    description: 'Stacked with signature coleslaw, pickled radish, spinach, carrots and seaweed salad. All topped with our famous house sauces and sunny side egg',
    price: 16.25,
    category: 'bibimbap',
    image: '/images/bibimbap-crispy-chicken.jpg',
    allergens: ['gluten', 'eggs', 'soy', 'sesame'],
  },
  {
    id: 'bib-4',
    name: 'Bibimbap Crispy Tofu',
    description: 'Stacked with signature coleslaw, pickled radish, spinach, carrots and seaweed salad. All topped with our famous house sauces and sunny side egg',
    price: 16.25,
    category: 'bibimbap',
    image: '/images/bibimbap-tofu.jpg',
    vegetarian: true,
    allergens: ['gluten', 'eggs', 'soy', 'sesame'],
  },

  // Street Style
  {
    id: 'street-1',
    name: 'The Seoul Stack',
    description: 'Crispy black angus beef with our secret house sauces, melted cheese, crispy bacon, sunny side egg, lettuce, tomato, pickles and potato sticks. Served with brioche bun and fries',
    price: 14.55,
    category: 'street-style',
    image: '/images/seoul-stack-single.jpg',
    popular: true,
    allergens: ['gluten', 'dairy', 'eggs', 'soy'],
  },
  {
    id: 'street-2',
    name: 'The Double Trouble',
    description: 'Double crispy black angus beef, double cheese, double crispy bacon, sunny side egg, lettuce, tomato, pickles and potato sticks. Served with brioche bun and fries',
    price: 17.85,
    category: 'street-style',
    image: '/images/double-trouble.jpg',
    allergens: ['gluten', 'dairy', 'eggs', 'soy'],
  },
  {
    id: 'street-3',
    name: 'K-Style Chicken Sandwich',
    description: 'Crispy fried chicken glazed in our special sauce, stacked with our signature coleslaw and house sauces on a toasted brioche bun. Served with fries',
    price: 14.55,
    category: 'street-style',
    image: '/images/k-style-chicken-sandwich.jpg',
    allergens: ['gluten', 'eggs', 'soy', 'dairy'],
  },

  // K-Bomb Fried Chicken (All plain fried chicken is gluten free)
  {
    id: 'kbomb-tenders-6',
    name: 'Chicken Tenders (6 pcs)',
    description: 'Crispy chicken tenders. Tossed in sauce or plain. All plain fried chicken is gluten free',
    price: 10.55,
    category: 'fried-chicken',
    image: '/images/chicken-tenders.jpg',
    options: [
      { id: 'tenders-plain', name: 'Plain (GF)', price: 0 },
      { id: 'tenders-butter-seoul', name: 'Butter Seoul', price: 0 },
      { id: 'tenders-soy-garlic', name: 'Soy Garlic', price: 0 },
      { id: 'tenders-korean-bbq', name: 'Korean BBQ', price: 0 },
      { id: 'tenders-sweet-heat', name: 'Sweet Heat & Glaze', price: 0 },
    ],
    allergens: ['gluten', 'soy'],
  },
  {
    id: 'kbomb-tenders-12',
    name: 'Chicken Tenders (12 pcs)',
    description: 'Crispy chicken tenders. Tossed in sauce or plain. All plain fried chicken is gluten free',
    price: 18.95,
    category: 'fried-chicken',
    image: '/images/chicken-tenders.jpg',
    options: [
      { id: 'tenders-plain', name: 'Plain (GF)', price: 0 },
      { id: 'tenders-butter-seoul', name: 'Butter Seoul', price: 0 },
      { id: 'tenders-soy-garlic', name: 'Soy Garlic', price: 0 },
      { id: 'tenders-korean-bbq', name: 'Korean BBQ', price: 0 },
      { id: 'tenders-sweet-heat', name: 'Sweet Heat & Glaze', price: 0 },
    ],
    allergens: ['gluten', 'soy'],
  },
  {
    id: 'kbomb-wings-6',
    name: 'Chicken Wings (6 pcs)',
    description: 'Korean-style wings. Tossed in sauce or plain. All plain fried chicken is gluten free',
    price: 11.25,
    category: 'fried-chicken',
    image: '/images/chicken-wings.jpg',
    options: [
      { id: 'wings-plain', name: 'Plain (GF)', price: 0 },
      { id: 'wings-butter-seoul', name: 'Butter Seoul', price: 0 },
      { id: 'wings-soy-garlic', name: 'Soy Garlic', price: 0 },
      { id: 'wings-korean-bbq', name: 'Korean BBQ', price: 0 },
      { id: 'wings-sweet-heat', name: 'Sweet Heat & Glaze', price: 0 },
    ],
    allergens: ['gluten', 'soy'],
  },
  {
    id: 'kbomb-wings-12',
    name: 'Chicken Wings (12 pcs)',
    description: 'Korean-style wings. Tossed in sauce or plain. All plain fried chicken is gluten free',
    price: 19.25,
    category: 'fried-chicken',
    image: '/images/chicken-wings.jpg',
    options: [
      { id: 'wings-plain', name: 'Plain (GF)', price: 0 },
      { id: 'wings-butter-seoul', name: 'Butter Seoul', price: 0 },
      { id: 'wings-soy-garlic', name: 'Soy Garlic', price: 0 },
      { id: 'wings-korean-bbq', name: 'Korean BBQ', price: 0 },
      { id: 'wings-sweet-heat', name: 'Sweet Heat & Glaze', price: 0 },
    ],
    allergens: ['gluten', 'soy'],
  },
  {
    id: 'kbomb-boneless-6',
    name: 'Boneless Chicken Wings (6 pcs)',
    description: 'Boneless wings. Tossed in sauce or plain. All plain fried chicken is gluten free',
    price: 11.25,
    category: 'fried-chicken',
    image: '/images/kbomb-chicken.jpg',
    options: [
      { id: 'boneless-plain', name: 'Plain (GF)', price: 0 },
      { id: 'boneless-butter-seoul', name: 'Butter Seoul', price: 0 },
      { id: 'boneless-soy-garlic', name: 'Soy Garlic', price: 0 },
      { id: 'boneless-korean-bbq', name: 'Korean BBQ', price: 0 },
      { id: 'boneless-sweet-heat', name: 'Sweet Heat & Glaze', price: 0 },
    ],
    allergens: ['gluten', 'soy'],
  },
  {
    id: 'kbomb-boneless-12',
    name: 'Boneless Chicken Wings (12 pcs)',
    description: 'Boneless wings. Tossed in sauce or plain. All plain fried chicken is gluten free',
    price: 19.25,
    category: 'fried-chicken',
    image: '/images/kbomb-chicken.jpg',
    options: [
      { id: 'boneless-plain', name: 'Plain (GF)', price: 0 },
      { id: 'boneless-butter-seoul', name: 'Butter Seoul', price: 0 },
      { id: 'boneless-soy-garlic', name: 'Soy Garlic', price: 0 },
      { id: 'boneless-korean-bbq', name: 'Korean BBQ', price: 0 },
      { id: 'boneless-sweet-heat', name: 'Sweet Heat & Glaze', price: 0 },
    ],
    allergens: ['gluten', 'soy'],
  },

  // KPC Plates
  {
    id: 'plate-1',
    name: 'Fried Chicken Plate - 1 pc Chicken Thigh Boneless',
    description: 'Includes white steamed rice and Korean style coleslaw. Chicken not tossed',
    price: 12.99,
    category: 'plates',
    image: '/images/fried-chicken-plate.jpg',
    allergens: ['gluten', 'soy', 'sesame', 'dairy'],
  },
  {
    id: 'plate-2',
    name: 'Fried Chicken Plate - 2 pcs Fried Chicken Tenders',
    description: 'Includes white steamed rice and Korean style coleslaw. Chicken not tossed',
    price: 12.99,
    category: 'plates',
    image: '/images/fried-chicken-plate.jpg',
    allergens: ['gluten', 'soy', 'sesame', 'dairy'],
  },

  // Kids Meal
  {
    id: 'kids-1',
    name: 'Kids Meal',
    description: '4 chicken nuggets and fries',
    price: 9.99,
    category: 'kids',
    image: '/images/kids-tender.jpg',
    allergens: ['gluten', 'soy'],
  },

  // Sides
  {
    id: 'side-1',
    name: 'Plain Fries',
    description: 'Crispy golden fries',
    price: 6.55,
    category: 'sides',
    image: '/images/fries.jpg',
    allergens: [],
  },
  {
    id: 'side-2',
    name: 'Plain Tater Tots',
    description: 'Crispy potato tater tots',
    price: 6.55,
    category: 'sides',
    image: '/images/tater-toast-plain.jpg',
    allergens: ['gluten'],
  },
  {
    id: 'side-3',
    name: 'Plain Rice',
    description: 'White steamed rice',
    price: 4.15,
    category: 'sides',
    image: '/images/plain-rice.jpg',
    allergens: [],
  },
  {
    id: 'side-4',
    name: 'Korean Style Coleslaw',
    description: 'Fresh cabbage with Korean dressing',
    price: 5.25,
    category: 'sides',
    image: '/images/coleslaw.jpg',
    allergens: ['dairy', 'sesame'],
  },
  {
    id: 'side-5',
    name: 'Corn Cheese',
    description: 'Sweet corn with melted cheese',
    price: 7.85,
    category: 'sides',
    image: '/images/corn-cheese.jpg',
    popular: true,
    allergens: ['dairy'],
  },
  {
    id: 'side-6',
    name: 'Boneless Skinless Chicken Thigh',
    description: 'Extra protein - boneless skinless chicken thigh',
    price: 3.55,
    category: 'sides',
    image: '/images/chicken-tenders.jpg',
    allergens: [],
  },
  {
    id: 'side-7',
    name: 'Extra Protein - Bulgogi Beef',
    description: 'Extra bulgogi beef',
    price: 5.50,
    category: 'sides',
    image: '/images/tater-toast-bulgogi.jpg',
    allergens: ['soy', 'sesame'],
  },
  {
    id: 'side-8',
    name: 'Extra Protein - Chicken/Tofu',
    description: 'Extra chicken or tofu',
    price: 3.55,
    category: 'sides',
    image: '/images/chicken-tenders.jpg',
    allergens: ['soy'],
  },
  {
    id: 'side-9',
    name: 'Soda',
    description: 'Refreshing soda',
    price: 3.50,
    category: 'sides',
    image: '/images/soda.jpg',
    allergens: [],
  },
  {
    id: 'side-make-meal',
    name: 'Make a Meal',
    description: '1 Soda + 1 Side',
    price: 7.00,
    category: 'sides',
    image: '/images/make-a-meal.jpg',
    allergens: [],
  },
];

export default menuItems;
